import React from 'react';

export const ChoiceButtonIcon = ({ imgUrl, isPen }: { imgUrl: string; isPen: boolean }) => {
  return (
    <div
      style={{
        height: '100%',
        backgroundImage: `url(${imgUrl})`,
        backgroundPosition: isPen ? '50% 50%' : '50% 0%',
        backgroundSize: isPen ? 'contain' : '100% auto',
        backgroundRepeat: 'no-repeat',
        aspectRatio: '1 / 1'
      }}
    />
  );
};
